import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, getCurrentUrl, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  /**
   * Подсвечивать только на точном совпадении адреса.
   *
   * По умолчанию `checkIsActive` матчит подстрокой, и пункт остаётся
   * подсвеченным на всех вложенных адресах — для большинства разделов это
   * правильно: со страницы редактирования подсвечен родительский пункт.
   *
   * Но когда адрес одного пункта оказывается началом адреса соседнего
   * (`/apps/subscription` и `/apps/subscription/free-requests`), подсветка
   * загорается сразу у обоих, и непонятно, где ты находишься.
   *
   * Флаг, а не общая правка `checkIsActive`: подстрочный матч нужен всем
   * остальным пунктам меню, и менять его ради одного случая — значит
   * трогать подсветку во всём приложении.
   */
  exact?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  exact = false,
}) => {
  const {pathname} = useLocation()
  const isActive = exact
    ? getCurrentUrl(pathname) === to
    : checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
